module.exports = __webpack_public_path__ + "assets/8b2b2aae46819bb8c37c438760dbb4f6.woff";


//////////////////
// WEBPACK FOOTER
// ../~/@fontsource/roboto/files/roboto-all-700-normal.woff
// module id = 276
// module chunks = 121